module.exports = __webpack_public_path__ + "img/Training.abed759d.png";